var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18,17l-3-3,3-3a.7.7,0,0,0,0-1,.72.72,0,0,0-1,0l-3,3-3-3a.73.73,0,0,0-1,0,.7.7,0,0,0,0,1l3,3-3,3a.71.71,0,1,0,1,1l3-3,3,3a.71.71,0,1,0,1-1Z","transform":"translate(-4.1 -4.1)","key":0}),React.createElement("path",{"d":"M21,7a9.9,9.9,0,1,0,2.9,7A9.91,9.91,0,0,0,21,7ZM20,8a8.56,8.56,0,0,1,2.32,4.35,8.48,8.48,0,1,1-16.64,0,8.48,8.48,0,0,1,5.07-6.19A8.48,8.48,0,0,1,20,8Z","transform":"translate(-4.1 -4.1)","key":1})]);
}

Cancel.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 19.8 19.8"};

module.exports = Cancel;

Cancel.default = Cancel;
